import { render, staticRenderFns } from "./DisplayImage.vue?vue&type=template&id=42a5503c&scoped=true&"
import script from "./DisplayImage.vue?vue&type=script&lang=js&"
export * from "./DisplayImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a5503c",
  null
  
)

export default component.exports